import { NewgenusRoute } from '@newgenus/common';

/**
 * Does a `routes/*` doc authorise this URL?
 *
 * The guard has always matched the EXACT url (query string stripped) against `route`. A module
 * with deep URLs (the issue tracker's /app/issues/board and /app/issues/ISS-012) would need one
 * route doc per URL — impossible for ids — so a doc may also carry `matchPrefix`: any url that
 * starts with it is covered by the same doc (same feature/module/public gates).
 */
export function routeMatchesUrl(routeDoc: Pick<NewgenusRoute, 'route' | 'matchPrefix'>, url: string): boolean {
    if (routeDoc.route === url) return true;
    const prefix = routeDoc.matchPrefix;
    return typeof prefix === 'string' && prefix.length > 0 && url.startsWith(prefix);
}
